<script>
import { mapState } from 'vuex'
import Request from '@src/mixins/request'
import headers from '@src/data/headers.json'
import CreateMemberDialog from '@components/create-member-dialog'
import MemberDetailDialog from '@components/member-detail-dialog'
import { authComputed } from '@state/helpers'

export default {
  metaInfo: {
    title: 'Member',
    meta: [{ name: 'description', content: 'Member' }],
  },

  $_veeValidate: { validator: 'new' },

  components: { CreateMemberDialog, MemberDetailDialog },

  mixins: [Request],

  props: {
    titles: {
      type: Array,
      default: () => [],
    },
    countries: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      headers: headers.member,
      items: [],
      item: {},
      color: 'gold',
      createDialog: false,
      detailDialog: false,
      filter: {
        id: '',
        name: '',
        email: '',
        country: '',
      },
    }
  },

  computed: {
    ...authComputed,
    ...mapState('app', {
      propertyId: (state) => state.currentProperty.id,
    }),
    tableHeaders() {
      const th = this.headers.slice(0)
      th.push({ text: 'Actions', sortable: false, align: 'right' })
      return th
    },
    countryList() {
      const cl = this.countries.slice(0)
      cl.unshift({ id: '', code: '', name: 'All' })
      return cl
    },
  },

  methods: {
    async findMember() {
      const data = {
        propertyId: this.propertyId,
        filter: this.filter,
      }
      this.items = await this.fetchData({
        url: this.endpoint.member.list,
        data,
      })
    },
    showMemberDetail(item) {
      this.item = item
      this.detailDialog = true
    },
    can(permission) {
      return this.havePermission(permission)
    },
  },
}
</script>

<template>
  <BaseView title="Member" :color="color">
    <!-- Toolbar Extension -->
    <VContainer slot="toolbar-extension" class="px-0" grid-list-xl>
      <VLayout row wrap>
        <VFlex xs12 sm4>
          <VTextField
            v-model.number="filter.id"
            v-validate="'numeric'"
            data-vv-name="ID"
            label="ID"
            :error-messages="errors.collect('ID')"
            :color="color"
            clearable
          />
        </VFlex>

        <VFlex xs12 sm4>
          <VTextField
            v-model="filter.name"
            label="Name"
            :color="color"
            clearable
          />
        </VFlex>

        <VFlex xs12 sm4>
          <VTextField
            v-model="filter.email"
            label="Email"
            :color="color"
            clearable
          />
        </VFlex>

        <VFlex xs12 sm4>
          <VAutocomplete
            v-model.number="filter.country"
            :items="countryList"
            :color="color"
            item-text="name"
            item-value="id"
            label="Country"
          />
        </VFlex>

        <VFlex xs12 sm2>
          <VBtn
            :disabled="errors.any()"
            :color="color"
            :dark="!errors.any()"
            depressed
            @click="findMember"
          >
            Search
          </VBtn>
        </VFlex>
      </VLayout>
    </VContainer>
    <!-- End of Toolbar Extension -->

    <!-- Slot toolbar-actions -->
    <VBtn
      v-if="isAdmin || can('edit-member')"
      slot="toolbar-actions"
      :color="color"
      depressed
      dark
      @click="createDialog = true"
    >
      Add
    </VBtn>
    <!-- End of Slot toolbar-actions -->

    <VDataTable
      :headers="tableHeaders"
      :items="items"
      :loading="loading ? color : false"
      hide-actions
    >
      <!-- Item Slot -->
      <template slot="items" slot-scope="props">
        <td
          v-for="(header, index) in headers"
          :key="`${header.text}-${index}`"
          :class="{ 'text-xs-right': header.align && header.align === 'right' }"
        >
          {{ props.item[header.value] }}
        </td>
        <td class="text-xs-right">
          <VIcon small @click="showMemberDetail(props.item)">
            remove_red_eye
          </VIcon>
        </td>
      </template>
      <!-- End Item Slot -->
    </VDataTable>

    <CreateMemberDialog v-model="createDialog" @member-added="findMember" />
    <MemberDetailDialog
      v-model="detailDialog"
      :item="item"
    ></MemberDetailDialog>
  </BaseView>
</template>
